'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var useContentSwitcher = require('./useContentSwitcher.js');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * ContentSwitcherButton
 *
 * A button that can be used to switch between content. It is used inside the
 * `ContentSwitcher` component.
 */
var ContentSwitcherButton = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  var switchProps = useContentSwitcher.useSwitch(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
  var switchStyles = _objectSpread({
    outline: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, styles["switch"]);
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.button, _extends__default["default"]({}, switchProps, {
    className: utils.cx('chakra-contentSwitcher__switch', props.className),
    __css: switchStyles
  }));
});
ContentSwitcherButton.displayName = 'ContentSwitcherButton';
exports.ContentSwitcherButton = ContentSwitcherButton;